import { ReactElement } from "react";
import type { IconProps } from "rivals/components/shared/Icons/iconPropsTypes";

const AlertNewspaper = ({
  height = "24px",
  width = "24px"
}: IconProps): ReactElement => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 16 16"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_11950_8154)">
        <path
          d="M8 16C12.4182 16 16 12.4182 16 8C16 3.58172 12.4182 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4182 3.58172 16 8 16Z"
          fill="#040404"
        />
        <g clipPath="url(#clip1_11950_8154)">
          <path
            clipRule="evenodd"
            d="M12.2316 4C12.4419 4 12.6312 4.07507 12.7784 4.2252H12.7994C12.9362 4.37534 13.0203 4.56836 13.0203 4.78284V10.8204C13.0203 11.1314 12.8941 11.4316 12.6732 11.6568C12.4524 11.8713 12.1579 12 11.853 12H3.17707C2.8721 12 2.57764 11.882 2.3568 11.6568C2.13596 11.4316 2.00977 11.1314 2.00977 10.8204V5.99464C2.00977 5.89812 2.04131 5.80161 2.11493 5.72654C2.25164 5.58713 2.50403 5.58713 2.64074 5.72654C2.70384 5.80161 2.7459 5.89812 2.7459 5.99464V10.8097C2.7459 10.9276 2.78797 11.0349 2.86158 11.1099C3.01933 11.2708 3.29275 11.2708 3.45049 11.1099C3.53462 11.0241 3.57669 10.9169 3.57669 10.8097V4.78284C3.57669 4.56836 3.6503 4.37534 3.79753 4.2252C3.94476 4.08579 4.13405 4 4.34437 4H12.2316ZM12.1264 11.1206C12.2105 11.0349 12.2526 10.9276 12.2526 10.8204L12.2421 10.8097V4.78284V4.76139H4.34437L4.32334 4.78284V10.8311C4.32334 10.9705 4.30231 11.1099 4.24973 11.2493H11.8319C11.9476 11.2493 12.0528 11.1957 12.1264 11.1206ZM10.2667 6.80957H6.32315C6.21798 6.80957 6.12334 6.85247 6.06024 6.91681C5.98663 6.99188 5.95508 7.08839 5.95508 7.18491C5.95508 7.28142 5.99714 7.38866 6.06024 7.453C6.13385 7.52807 6.2285 7.56024 6.32315 7.56024H10.2667C10.3614 7.56024 10.456 7.51735 10.5296 7.453C10.6033 7.37794 10.6453 7.28142 10.6453 7.18491C10.6453 7.08839 10.6033 6.98115 10.5296 6.91681C10.456 6.84174 10.3614 6.80957 10.2667 6.80957ZM10.2667 8.41821H6.32315C6.21798 8.41821 6.12334 8.46111 6.06024 8.52545C5.98663 8.60052 5.95508 8.69703 5.95508 8.79355C5.95508 8.89006 5.99714 8.9973 6.06024 9.06164C6.13385 9.13671 6.2285 9.16888 6.32315 9.16888H10.2667C10.3614 9.16888 10.456 9.12599 10.5296 9.06164C10.6033 8.98658 10.6453 8.89006 10.6453 8.79355C10.6453 8.69703 10.6033 8.58979 10.5296 8.52545C10.456 8.45038 10.3614 8.41821 10.2667 8.41821Z"
            fill="white"
            fillRule="evenodd"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_11950_8154">
          <rect fill="white" height="16" width="16" />
        </clipPath>
        <clipPath id="clip1_11950_8154">
          <rect fill="white" height="8" transform="translate(2 4)" width="11" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AlertNewspaper;
